// native
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

// service
import { ApiService } from './api.service';
import { GlobalsService } from './globals.service';

// models
import { ICollection, ICollectionDataResponse } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CollectionsService {

  personalLibrary: ICollection;

  currentLibrary$: Subject<ICollection> = new Subject<ICollection>();

  collections: ICollection[];

  constructor(
    private apiService: ApiService,
    private globalsService: GlobalsService
  ) { }

  getCollections(): Observable<ICollection[]> {
    const url = `${this.globalsService.appConfig.environment.baseUrls.services}/collections`;

    return this.apiService.get(url).pipe(
      map((body: ICollectionDataResponse) => this.mapCollectionData(body.collections || [])),
      tap((collections: ICollection[]) => {
        this.setPersonalLibrary(collections.filter(collection => !collection.shared && collection.status === 'active')[0]);
        this.collections = collections;
      })
    );
  }

  private mapCollectionData(collections: any[]): ICollection[] {
    return collections.map((collection: any) => {
      return {
        id: collection.id || '',
        name: collection.name || '',
        shared: collection.shared || false,
        status: collection.status,
        public_id: collection.public_id || null,
        last_reset_at: collection.last_reset_at || null,
        tip: collection.tip || null,
        organization: collection.organization || false,
        user: collection.user || {},
        custom_type_schema: collection.custom_type_schema || null,
        custom_fields: collection.custom_fields || []
      };
    });
  }

  setPersonalLibrary(collection: ICollection) {
    this.personalLibrary = Object.assign({}, collection);
  }
}